import React, { useCallback, useMemo } from "react";
import StatusPill from "../../../../components/Status/StatusPill.component";
import { ListActionComponent } from "../../../../components/CustomListHeader/CustomListHeader";
import constants from "../../../../config/constants";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import FilterComponent from "../../../../components/Filter/Filter.component";
import DatatableTable from "../../../../Datatables/Datatable.table";
import styles from "../Style.module.css";
import useReportedSideEffectsHook from "./ReportedSideEffectsHooks";
import { useSelector } from "react-redux";
import classNames from "classnames";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";

const ReportedSideEffectsList = ({ data }) => {
  const {
    configFilter,
    handleDetail,
    handleSortOrderChange,
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
  } = useReportedSideEffectsHook({});

  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.side_effects);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    }
  }, []);

  const renderFirstCell = useCallback((program) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(program?.name)}`} </div>
        </div>
      </div>
    );
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "medicine",
        label: "Medicine",
        sortable: true,
        render: (value, all) => <div>{capitalizeFirstLetter(all?.medicine_name)}</div>
      },

      {
        key: "client",
        label: "Client",
        sortable: false,
        render: (temp, all) => <div>{capitalizeFirstLetter(all?.client_name)}</div>
      },
      {
        key: "program",
        label: "Program",
        sortable: false,
        render: (temp, all) => <div>{capitalizeFirstLetter(all?.program_name)}</div>,
      },
      {
        key: "reported",
        label: "Reported On",
        sortable: false,
        render: (temp, all) => <div>{all?.createdAtText}</div>,
      },
      {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.listActionContainer}>
            <ListActionComponent
              allData={all}
              handleDetail={handleDetail}
              key={all?.id}
            />
          </div>
        ),
      },
    ],
    [handleDetail]
  );

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [handleSortOrderChange, handlePageChange, tableStructure, present, allData.length, currentPage]);
  return (
    <div>
      <ShadowBox width={"100%"}>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={configFilter}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder="Search by medicine or program name"
          />
          <div>
            <br />
            <div style={{ width: "100%" }}>
              <DatatableTable
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default ReportedSideEffectsList;
